export enum FEATURE {
    CONFERENCE = 'conference',
    AUTHORIZATION = 'authorization',
    DEVICES = 'devices',
    DEVICE_ERRORS = 'device-errors',
    CONNECTION = 'connection',
    MUTE = 'mute',
    CHAT = 'chat',
    SHARING = 'sharing',
    ERROR_PAGE = 'error-page',
    WAITING_ROOM = 'waiting-rooms',
}

export enum ACTION {
    PARTICIPANT_VIDEO_ON = 'participant-video-on',
    LOGIN = 'login',
    SELECT_MIC = 'select-mic',
    SELECT_SPEAKER = 'select-speaker',
    SELECT_CAMERA = 'select-camera',
    SHOW_MODAL = 'show-modal',
    CLOSE_MODAL = 'close-modal',
    GO_TO_HELP = 'go-to-help',
    CREATE_CONFERENCE = 'create-conference',
    JOIN_CONFERENCE = 'join-conference',
    CONNECT_CONFERENCE = 'connect-conference',
    MIC_ON = 'mic-on',
    MIC_OFF = 'mic-off',
    CAMERA_ON = 'camera-on',
    CAMERA_OFF = 'camera-off',
    CREATE = 'create',
    OPEN = 'open',
    PUBLISH = 'publish',
    WATCH = 'watch',
    RETRY_RELOAD = 'retry-reload',
    RETRY_GO_HOME = 'retry-go-home',
    RETRY_CREATE_CALL = 'retry-create-call',
    CONNECT_GOLOOM = 'connect-goloom',
    JOIN_SETTINGS_SHOWN = 'join-settings-shown',
    CHANGE_PRIVACY = 'change-privacy',
    ALLOW_PARTICIPANT = 'allow-participant',
    ALLOW_SEVERAL = 'allow-several',
    WAITER = 'waiter',
}

export enum STATUS {
    SUCCESS = 'success',
    FAIL = 'fail',
}

/**
 * RUM каунтеры, статистику можно посмотреть здесь
 * https://rum.yandex-team.ru/projects/telemost/delta?componentSettings=%7B"delta"
 */
export enum COUNTERS {
    /**
     * Время первого подключения ко встрече
     */
    CONNECT_DELTA = 'connect_delta',
    /**
     * Время переподключения ко встрече при необходимости
     */
    RECONNECT_DELTA = 'reconnect_delta',
    /**
     * Мягкий реконнект
     */
    GRACEFULL_RECONNECT_DELTA = 'gracefull_reconnect_delta',
    /**
     * Время открытия сокета в Xiva
     */
    XIVA_SOCKET_OPEN_DELTA = 'xiva_socket_open_delta',
    /**
     * Время подписки на события Xiva
     */
    XIVA_SUBSCRIBE_DELTA = 'xiva_subscribe_delta',

    /**
     * Время набора ice кандидатов
     */
    ROOM_AGENT_ICE_GATHERING_DELTA = 'room_agent_ice_gathering_delta',

    /**
     * Время переключения состояния микрофона
     */
    TOGGLE_MUTE_MICROPHONE_DELTA = 'toggle_mute_microphone_delta',

    /**
     * Время переключения состояния камеры
     */
    TOGGLE_MUTE_CAMERA_DELTA = 'toggle_mute_camera_delta',

    /**
     * Время открытия чата
     */
    OPEN_CHAT_DELTA = 'open_chat_delta',

    /**
     * Время подключения к Голуму
     */
    CONNECT_GOLOOM_DELTA = 'connect_goloom_delta',

    /**
     * Время включения микрофона
     */
    UNMUTE_MICROPHONE_DELTA = 'unmute_microphone_delta',

    /**
     * Время включания камеры
     */
    UNMUTE_CAMERA_DELTA = 'unmute_camera_delta',
}
